<template>
  <div>
    <v-fab-transition>
      <v-btn fab dark color="green" absolute bottom small style="bottom: 15px" left class="v-btn--example" @click="addComment()"> <v-icon>mdi-plus</v-icon></v-btn>
    </v-fab-transition>
    <div class="comments-body px-2">
      <comment-row
        v-for="(el, i) in data"
        :key="i"
        :item="el"
        @click1="
          counter += 1;
          onDetectClick({ event: $event, row: el });
        "
        @click="onClickMessage(el, $event)"
        @onRead1="onReadMessage(el, $event)"
      />
    </div>
    <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
      <v-list v-if="menuItems" class="py-0">
        <v-list-item v-for="(item, index) in menuItems" :key="index" dense :disabled="!item.enable(currentComment)" @click="onClickMenu(item)">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-simple-table dense v-if="0">
      <tbody>
        <tr v-for="(el, i) in mess" :key="i">
          <td class="text-left" style="font-weight: 500; height: 38px">
            <div>
              {{ el.user_name }}:
              <div>{{ el.date.date }} {{ el.date.time }}</div>
            </div>
          </td>
          <td class="text-left px-0" style="height: 38px">
            {{ el.message }}
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <confirm-dialog ref="confirmDialog"></confirm-dialog>
    <comment-edit v-model="showEdit" :id="idEdit" :target="target" @delete="delComment($event)" />
  </div>
</template>

<script>
import { getAccess, doubleClickDetect } from "../../components/mixings";
export default {
  mixins: [getAccess, doubleClickDetect],
  components: {},
  props: {
    id: Number,
    needUpdate: Number,
    target: Object,
  },
  data() {
    return {
      idEdit: null,
      loading: false,
      title: "",
      x: 0,
      y: 0,
      currentComment: 0,
      showMenu: false,
      showEdit: false,
      target1: { name: "tasks" },
      menuItems: [
        {
          name: "answer",
          title: "Ответить",
          action: () => {
            this.addComment(this.currentComment);
          },
          enable: () => {
            return true;
          },
        },
        {
          name: "edit",
          title: "Редактировать",
          action: () => {
            this.editComment(this.currentComment);
          },
          enable: comment => {
            return comment && comment.user_id == this.$root.profile.id;
          },
        },
        {
          name: "delete",
          title: "Удалить",
          action: () => {
            this.delComment(this.currentComment);
          },
          enable: comment => {
            return comment && comment.user_id == this.$root.profile.id;
          },
        },
      ],
      data: {},

      model: [
        { name: "content", title: "Сообщение", type: "text" },
        { name: "status", default: 1 },
      ],
      url: "/mechti/comments",
      defaults: {
        sort: { key: "createdon", order: "DESC" },
        filters: { status: 1, target_name: this.target.name, target_id: this.id },
      },
    };
  },
  destoyed() {
    console.log("destroyed newComment");
    //this.$root.$off("newComment", this.checkNewComment);
  },
  created() {
    this.fitchData();
    //this.$root.$on("newComment", this.checkNewComment);
  },
  mounted() {},

  computed: {
    newComment() {
      return this.$store.getters["state/getNewComment"];
    },
    mess() {
      if (!this.messages) return [];
      return this.messages.sort((a, b) => {
        return (a.date < b.date) - (a.date > b.date);
      });
    },
  },
  watch: {
    newComment(v) {
      this.checkNewComment();
    },
    showEdit(v) {
      if (!v) {
        this.fitchData();
      }
    },
    needUpdate(v) {
      if (v) {
        this.fitchData();
      }
    },
  },
  methods: {
    checkNewComment(data) {
      console.log("checkNewComment", data);
      this.fitchData();
    },
    async fitchData() {
      this.loading = true;
      const params = {};
      params.filters = { target_name: "tasks", target_id: this.id };
      const d = await this.$axios.get(this.url, { params: this.defaults });
      if (d.data && d.data.data) {
        this.data = d.data.data;
      }
      this.loading = !true;
    },
    onClickMenu(item) {
      if (item.action) item.action(this.currentComment);
    },
    onSingleClick(d) {
      return this.onClickMessage(d.row, d.event);
    },
    onDoubleClick(d) {
      return this.onReadMessage(d.row, d.event);
    },

    onReadMessage(el, e) {
      if (el.viewedon) return;
      this.$axios.get(this.url + "/" + el.id);
      this.$store.dispatch("state/badges", "task_comments");
    },
    onClickMessage(el, e) {
      if (el.viewedon || el.createdby_id == this.$root.profile.id) {
        //this.showMenu = false;
        this.$nextTick(() => {
          this.showMenu = false;
          this.currentComment = el;
          this.x = e.clientX;
          this.y = e.clientY;
        });

        setTimeout(() => {
          this.showMenu = true;
        }, 50);
      } else {
        this.$axios.get(this.url + "/" + el.id);
        setTimeout(() => {
          this.$store.dispatch("state/badges", "task_comments");
        }, 500);

        el.viewedon = 1;
      }
    },
    addComment(c) {
      this.target.id = this.id || null;
      this.idEdit = 0;
      this.target.parent = c || null;
      console.log("add", this.id, c, this.target);
      this.showEdit = true;
    },
    async delComment(c) {
      console.log("delete");
      let ok = false;
      ok = await this.$refs.confirmDialog.show({
        title: "Удаление",
        message: [`Вы действительно хотите удалить комментарий?`],
        okButton: "Да",
        cancelButton: "Нет",
      });
      if (!ok) return;
      this.loading = true;
      let response = await this.$axios.post(this.url, { id: c.id, status: 0 });
      this.loading = false;
      let status = response.data.status == "ok";
      if (status) {
        this.$root.$emit("show-info", {
          text: "Комментарий удален",
        });
        this.fitchData();
      }
    },
    editComment(c) {
      this.target.id = this.id || null;
      this.idEdit = c?.id || 0;
      this.target.parent = c || null;
      console.log("add", this.id, c, this.target);
      this.showEdit = true;
      this.showEdit = true;
    },
  },
};
</script>
<style lang="scss"></style>
